module.exports = __webpack_public_path__ + "static/img/example_hzsj.fe1d542.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example_hzsj.jpg
// module id = nAra
// module chunks = 128